/* Home V2 scroll engine. Ported from REF (docs/superpowers/specs/reference/
   pe-rev2-draft.html): UTIL lines 2376-2394, MEASURE 2883+, FRAME 2932+,
   REVEALS 2848-2859, BOOT 3476-3521. One rAF loop, no layout reads in frame(). */
(function () {
  'use strict';
  // F1: this is the first thing the engine does. Removing hv2-no-js here,
  // before anything else runs, is what tells the CSS (.home-v2.hv2-no-js
  // rules in _turn.scss/_boards.scss) that JS is in fact driving the page —
  // if this line never executes, those rules stay live and the pinned
  // sequences fall back to a static, fully-readable stacked layout.
  var hv2NoJsRoot = document.querySelector('.home-v2');
  if (hv2NoJsRoot) { hv2NoJsRoot.classList.remove('hv2-no-js'); }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function clamp01(v){ return v < 0 ? 0 : v > 1 ? 1 : v; }
  function remap(v,a,b){ return clamp01((v - a) / (b - a || 1e-6)); }
  function smooth(t){ return t * t * (3 - 2 * t); }
  function lerp(a,b,t){ return a + (b - a) * t; }
  function hex(h){ return [parseInt(h.slice(1,3),16), parseInt(h.slice(3,5),16), parseInt(h.slice(5,7),16)]; }
  function mix(a,b,t){ var A=hex(a),B=hex(b);
    return 'rgb('+Math.round(lerp(A[0],B[0],t))+','+Math.round(lerp(A[1],B[1],t))+','+Math.round(lerp(A[2],B[2],t))+')'; }
  function absTop(el){ var t=0,n=el; while(n){ t += n.offsetTop; n = n.offsetParent; } return t; }
  function jump(dy){
    var h = document.documentElement, prev = h.style.scrollBehavior;
    h.style.scrollBehavior = 'auto'; window.scrollBy(0, dy); h.style.scrollBehavior = prev;
  }

  var components = [], rafId = null, vh = 0, docH = 0;
  var progress = null;

  function measureAll(){
    vh = window.innerHeight; docH = document.documentElement.scrollHeight;
    components.forEach(function(c){ if (c.measure) c.measure(vh, docH); });
    frame();
  }
  function frame(){
    rafId = null;
    var y = window.scrollY || window.pageYOffset;
    if (progress) progress.style.width = (clamp01(y / ((docH - vh) || 1)) * 100) + '%';
    components.forEach(function(c){ if (c.frame) c.frame(y, vh); });
  }
  function onScroll(){ if (rafId === null) rafId = requestAnimationFrame(frame); }

  window.PEHomeV2 = {
    reduce: reduce,
    utils: { clamp01: clamp01, remap: remap, smooth: smooth, lerp: lerp, mix: mix, absTop: absTop, jump: jump },
    register: function (c) { components.push(c); },
    _start: function () {
      progress = document.getElementById('hv2Progress');
      // reveals
      var rvs = document.querySelectorAll('.home-v2 .rv');
      if (reduce || !('IntersectionObserver' in window)) {
        rvs.forEach(function(el){ el.classList.add('in'); });
      } else {
        var io = new IntersectionObserver(function(es){
          es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
        }, { rootMargin: '0px 0px -8% 0px' });
        rvs.forEach(function(el){ io.observe(el); });
      }
      measureAll();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', measureAll);
      window.addEventListener('load', measureAll);
    }
  };
})();
